import { Module, forwardRef } from '@nestjs/common';
import { MongooseModule } from '@nestjs/mongoose';

import { CouponService } from './services/coupon.service';
import { CouponController } from './controllers/coupon.controller';
import { Coupon, CouponSchema } from './schemas/coupon.schema';

// Circular dependencies
import { OrderModule } from '../order/order.module';
import { LocationModule } from '../location/location.module';

@Module({
  imports: [
    MongooseModule.forFeature([{ name: Coupon.name, schema: CouponSchema }]),
    forwardRef(() => OrderModule),
    LocationModule,
  ],
  controllers: [CouponController],
  providers: [CouponService],
  exports: [CouponService, MongooseModule],
})
export class CouponModule {}
